import type { CrossFlowExtensions } from '@atlassiansox/cross-flow-base-types/CrossFlowExtensions';

import { type StartExtensionsOptions } from './types';
import { createProductExtensions } from './utils';

export { Editions } from './types';
export type { StartExtensionsOptions } from './types';

export const startExtensionsWhitelist: string[] = ['edition', 'migrationSourceUuid'];

export const createStartExtensions: (options: StartExtensionsOptions) => CrossFlowExtensions =
	createProductExtensions<StartExtensionsOptions>(startExtensionsWhitelist);
